import { Box, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react';
import Currency from '../../../common/Currency';
import DemandsForm from '../../../EmployeeView/Demands/DemandsForm';

class SessionDemands extends Component {
    state = {  }
    render() {
        const { DEMANDS, ARTICLES, EMPLOYEES, stats } = this.props;
        return (
            <Box>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Article</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Prix</TableCell>
                            <TableCell>Employé.e</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {DEMANDS && DEMANDS.map( item => 
                            <TableRow>
                                <TableCell>{new Date(item.demand_creation_date).toLocaleDateString("fr-FR")}</TableCell>
                                <TableCell>{ARTICLES[item.demand_article].article_name}</TableCell>
                                <TableCell>{item.demand_quantity}</TableCell>
                                <TableCell><Currency value={ARTICLES[item.demand_article].article_price} suffix={" "}/></TableCell>
                                <TableCell>{EMPLOYEES[item.demand_employee].employee_firstname} {EMPLOYEES[item.demand_employee].employee_lastname}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                                <TableCell colSpan={2}></TableCell>
                                <TableCell>{stats.nbArticles}</TableCell>
                                <TableCell><Currency value={stats.totalPrice} /></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                    </TableFooter>
                </Table>

            </Box>
        );
    }
}

export default SessionDemands;